import {
  ListTemplateMessageSuggestions,
  ListTemplateMessageSuggestionsVariables
} from './__generated__/ListTemplateMessageSuggestions'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query ListTemplateMessageSuggestions($input: ListTemplateMessageSuggestionsInputV2!) {
    listTemplateMessageSuggestions: listTemplateMessageSuggestionsV2(input: $input) {
      templateMessageSuggestions {
        id
        created
        message {
          id
          characters
          text
          cardSize
        }
      }
      nextCursor
    }
  }
`

export const useListTemplateMessageSuggestions = (variables: ListTemplateMessageSuggestionsVariables) => {
  return useQuery<ListTemplateMessageSuggestions, ListTemplateMessageSuggestionsVariables>(QUERY, {
    fetchPolicy: 'cache-and-network',
    variables
  })
}
